import React from 'react';

const Unit: React.FC<{ className?: string }> = ({ className }) => {
  return <div className={className} />
}

export default Unit;
